import localforage from 'localforage'

class Operateur {
    static getOperateurOption(callback) {
        localforage
            .getItem('listOptions')
            .then(options => {
                callback(JSON.parse(options))
            })
            .catch(err => {
            })
    }

    static getOperateurOptions() {
        return new Promise((resolve, reject) => {
            localforage
                .getItem('listOptions')
                .then(options => {
                    resolve(JSON.parse(options))
                })
                .catch(err => {
                    reject(err)
                })
        })
    }
}

export default Operateur



// WEBPACK FOOTER //
// ./src/js/models/Operateur.js